import type { DisplayConfigItem } from '../../../platform/display-descriptors';

/**
 * 商品卡片排除：独立 architecture 行由 finalize 合并进镜像 tag；公共环境变量不进卡片/下单 displayConfig。
 * 直建「确认」摘要仍可展示 envVars；SKU/下单「配置预览」见 APP_INSTANCE_CONFIG_PREVIEW_EXCLUDED_MODULES。
 */
export const APP_INSTANCE_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS = new Set(['architecture']);

/** 动态环境变量行 common_env_*；镜像卡片明细行 app_image_meta_*（商品卡只留 app_image 名称） */
export const APP_INSTANCE_PRODUCT_CARD_EXCLUDED_DISPLAY_ID_PREFIXES = ['common_env_', 'app_image_meta_'] as const;

/** SKU ResourcePreview / 下单 ConfView 配置预览不展示的模块（编辑区仍可配） */
export const APP_INSTANCE_CONFIG_PREVIEW_EXCLUDED_MODULES = new Set(['envVars']);

function hasDisplayValue(item: DisplayConfigItem): boolean {
  return String(item.value ?? '').trim() !== '';
}

export function isAppInstanceProductCardDisplayId(id: string | undefined | null): boolean {
  const safeId = String(id ?? '').trim();
  if (!safeId) return true;
  if (APP_INSTANCE_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS.has(safeId)) return false;
  if (APP_INSTANCE_PRODUCT_CARD_EXCLUDED_DISPLAY_ID_PREFIXES.some((prefix) => safeId.startsWith(prefix))) return false;
  return true;
}

export function filterAppInstanceProductCardDisplayConfig(items: DisplayConfigItem[]): DisplayConfigItem[] {
  return items.filter((item) => item && isAppInstanceProductCardDisplayId(item.id) && hasDisplayValue(item));
}
